/**
 * Design variants — config "stile" frontend selezionabile da admin.
 * Singola riga in `settings` table con key='design_variants'.
 */

export type FontPrimary = 'manrope' | 'jakarta' | 'outfit';
export type BoatCardStyle = 'classic' | 'airbnb_square' | 'minimal';
export type BoatDetailGallery = 'carousel' | 'grid_2x2';
export type BoatDetailSections = 'card_boxed' | 'divider_line';
export type CatalogBg = 'flat' | 'gradient' | 'noise';
export type HomePremiumStyle = 'snap_y' | 'single_page';

export interface DesignVariants {
  font_primary: FontPrimary;
  boat_card_style: BoatCardStyle;
  boat_detail_gallery: BoatDetailGallery;
  boat_detail_sections: BoatDetailSections;
  catalog_bg: CatalogBg;
  home_premium_style: HomePremiumStyle;
}

/** Defaults = stato attuale (no break). */
export const DEFAULT_DESIGN_VARIANTS: DesignVariants = {
  font_primary: 'manrope',          // appena swappato a Manrope
  boat_card_style: 'classic',       // stato corrente BoatCard
  boat_detail_gallery: 'carousel',  // stato corrente BoatDetailView
  boat_detail_sections: 'divider_line', // ho appena uniformato sezioni a border-t? su feature/vendor branch no, classic resta card_boxed
  catalog_bg: 'flat',               // bg-slate-100
  home_premium_style: 'snap_y',     // snap-y attuale
};

export const FONT_PRIMARY_OPTIONS: { value: FontPrimary; label: string }[] = [
  { value: 'manrope', label: 'Manrope (Airbnb-like)' },
  { value: 'jakarta', label: 'Plus Jakarta Sans' },
  { value: 'outfit', label: 'Outfit' },
];

export const BOAT_CARD_STYLE_OPTIONS: { value: BoatCardStyle; label: string; desc: string }[] = [
  { value: 'classic',       label: 'Classico', desc: 'Aspect 16:9 + shadow + badge floating' },
  { value: 'airbnb_square', label: 'Airbnb Square', desc: 'Aspect 1:1 + gallery hover + minimal' },
  { value: 'minimal',       label: 'Minimal',  desc: 'Aspect 4:3 + no badge + prezzo inline' },
];

export const BOAT_DETAIL_GALLERY_OPTIONS: { value: BoatDetailGallery; label: string; desc: string }[] = [
  { value: 'carousel', label: 'Carosello',  desc: 'Singola immagine + prev/next + thumb strip' },
  { value: 'grid_2x2', label: 'Grid 2×2',   desc: '1 grande sx + 4 piccole dx Airbnb-style' },
];

export const BOAT_DETAIL_SECTIONS_OPTIONS: { value: BoatDetailSections; label: string; desc: string }[] = [
  { value: 'card_boxed',   label: 'Card boxed',   desc: 'rounded border shadow per ogni sezione' },
  { value: 'divider_line', label: 'Divider line', desc: 'pt-8 border-t Airbnb minimal' },
];

export const CATALOG_BG_OPTIONS: { value: CatalogBg; label: string; desc: string }[] = [
  { value: 'flat',     label: 'Flat',     desc: 'bg-slate-100 piatto' },
  { value: 'gradient', label: 'Gradient', desc: 'white → slate-50 → white' },
  { value: 'noise',    label: 'Noise',    desc: 'Gradient + grana SVG texture' },
];

export const HOME_PREMIUM_STYLE_OPTIONS: { value: HomePremiumStyle; label: string; desc: string }[] = [
  { value: 'snap_y',      label: 'Snap-y',      desc: 'Scroll obbligato a sezioni full-screen' },
  { value: 'single_page', label: 'Single page', desc: 'Scroll normale, sezioni libere' },
];

/** Merge config user con defaults — qualsiasi chiave mancante eredita default. */
export function mergeDesignVariants(stored: Partial<DesignVariants> | null | undefined): DesignVariants {
  return { ...DEFAULT_DESIGN_VARIANTS, ...(stored || {}) };
}
